import type { OfferAttachment } from '../../../types';

export function isUploadedOfferAttachment(attachment: { object_path: string }): boolean {
  return attachment.object_path.includes('/offer-attachments/');
}

export async function uploadOfferAttachment(leadRouteId: string, file: File): Promise<OfferAttachment> {
  const fd = new FormData();
  fd.append('file', file);
  const res = await fetch(`/api/leads/${encodeURIComponent(leadRouteId)}/offer-attachments`, {
    method: 'POST',
    body: fd,
    credentials: 'include',
  });
  const payload = (await res.json().catch(() => ({}))) as { error?: string } & Partial<OfferAttachment>;
  if (!res.ok) throw new Error(payload.error || `Upload fehlgeschlagen (${res.status})`);
  return payload as OfferAttachment;
}

export async function deleteOfferAttachmentStorage(
  leadRouteId: string,
  attachment: OfferAttachment,
): Promise<void> {
  if (!isUploadedOfferAttachment(attachment)) return;
  const res = await fetch(`/api/leads/${encodeURIComponent(leadRouteId)}/offer-attachments`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ object_path: attachment.object_path }),
  });
  if (!res.ok) {
    const payload = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(payload.error || `Löschen fehlgeschlagen (${res.status})`);
  }
}
